import { render } from "./Protocol.vue?vue&type=template&id=52002461&scoped=true"
import script from "./Protocol.vue?vue&type=script&lang=js"
export * from "./Protocol.vue?vue&type=script&lang=js"

import "./Protocol.vue?vue&type=style&index=0&id=52002461&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52002461"]])

export default __exports__